import { baseReducerState, BaseReducerState } from "Store/Shared/Store/PropTypes";

export type CandidateId = string;

export interface CandidateState extends BaseReducerState<CandidateId> {
    unsaved: {},
    saved: {},
    new: '',
    isLoading: boolean,
    createFlowId: string | null
}

export const initialCandidateState: CandidateState = {
    ...baseReducerState,
    unsaved: {},
    saved: {},
    new: '',
    isLoading: false,
    createFlowId: null
}